MultiDialog = App.loadClass 'core::MultiDeleteDialog'


$ () ->
    $.widget 'custom.multidelete',
        options:
            targetSelector: null,
            delModeClass: 'alert alert-success'
            delSelectClass: 'alert alert-error'
            delUrl: null
            dataKey: 'db_id'
            dataName: 'db_name'
            afterHidden: () -> undefined
            onStart: () -> undefined

        _create: () ->
            ths = this
            @options.targetSelector = @options.targetSelector ? @element.data('multidelete-selector')

            # If the table is empty disable the delete button
            if $(@options.targetSelector).children().hasClass('dataTables_empty')
                @element.prop('disabled', true)

            @element.click () ->
                inDeleteMode = ths.mode ? false
                if not inDeleteMode
                    ths.startDelete()
                    ths.mode = true
                else
                    ths.finishDelete()
                    ths.mode = false

        _setOption: () ->
            undefined

        inDeleteMode: () ->
            return @mode ? false


        destroy: () ->
            undefined

        startDelete: () ->
            ths = this
            @selectedCount = 0

            @prevHtml = @element.html()
            @element.html "<i class='fa fa-remove'></i> Cancel Deletion"

            ths.options.onStart()

            target = $(@options.targetSelector)

            @restoreStriped = false

            if target.parents('table').hasClass('table-striped')
                @restoreStriped = true
                target.parents('table').removeClass('table-striped')

            target.each () ->
                $(this).addClass ths.options.delModeClass

            target.bind 'click', () ->
                selected = $(this).data('multidelete-selected') ? false

                if not selected
                    ths.selectedCount += 1
                    $(this).addClass('multidelete-del').addClass ths.options.delSelectClass
                    $(this).removeClass ths.options.delModeClass
                    $(this).data 'multidelete-selected', true

                else
                    ths.selectedCount -= 1
                    $(this).removeClass('multidelete-del').removeClass ths.options.delSelectClass
                    $(this).addClass ths.options.delModeClass
                    $(this).data 'multidelete-selected', false

                # If there is nothing selected to delete then display the cancel button
                if ths.selectedCount > 0
                    ths.element.html "<i class='fa fa-trash-alt'></i> Delete Selected"
                else
                    ths.element.html "<i class='fa fa-remove'></i> Cancel Deletion"


        finishDelete: () ->
            # confirm deletion?
            # if no, quit. if yes....

            ths = this
            # grab all selectors who are also part of the multidelete-del class
            target = $(@options.targetSelector).filter('.multidelete-del')
            total = target.length

            if total is 0
                ths._cleanUp()
                return 0

            saveData =
                objects: []

            target.each () ->
                el = $(this)
                saveData.objects.push
                    id: el.data ths.options.dataKey
                    name: el.data ths.options.dataName
                    element: el

            ###
                This... is not so great. I want this to be subhandled somehow.
                But that kind of implies that multidelete should somehow be a subhandler
                of it's own. Maybe instead of a jquery widget, it becomes a subhandler you init
                that automatically includes the multidelete button, and you set some attributes
                to tell it which table to point at and such.
            ###
            dlg = new MultiDialog()
            dlg.saveUrl = ths.options.delUrl
            dlg.saveData = saveData
            dlg.multi_widget = this
            dlg.init()


        _cleanUp: () ->
            ths = this
            ths.options.afterHidden()
            @element.html @prevHtml
            target = $(@options.targetSelector)
            target.unbind 'click'

            if @restoreStriped
                target.parents('table').addClass('table-striped')

            target.each () ->
                $(this).removeClass ths.options.delModeClass
                $(this).removeClass ths.options.delSelectClass
                $(this).removeClass 'multidelete-del'
                $(this).removeData('multidelete-selected')
